import { Icon } from './Icons.jsx';

export function Modal({ open, onClose, title, children, width = 520 }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="card fade-up modal-card"
        style={{ maxWidth: width }}
      >
        <div className="flex items-center justify-between modal-head">
          <h3 style={{ fontSize: 18 }}>{title}</h3>
          <button className="btn btn-ghost btn-sm" onClick={onClose} aria-label="Cerrar"><Icon.close /></button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="page-header flex items-center justify-between">
      <div>
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="muted page-subtitle">{subtitle}</p>}
      </div>
      {children && <div className="page-header-acciones flex items-center gap-sm">{children}</div>}
    </div>
  );
}

export function EmptyState({ icon = 'box', titulo, texto }) {
  const IconCmp = Icon[icon] || Icon.box;
  return (
    <div className="card" style={{ padding: '60px 20px', textAlign: 'center' }}>
      <div style={{ color: 'var(--text-muted)', display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
        <IconCmp width={42} height={42} />
      </div>
      <h3 style={{ marginBottom: 6 }}>{titulo}</h3>
      {texto && <p className="muted">{texto}</p>}
    </div>
  );
}

export function Loading({ texto = 'Cargando...' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, padding: 60, color: 'var(--text-muted)' }}>
      <div className="spinner" />
      <span>{texto}</span>
    </div>
  );
}
